exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-users-container {\n  padding: 20px 30px;\n  border: 1px solid #BABBC7;\n  border-radius: 5px;\n  background-color: white;\n  font-size: 12px;\n  font-weight: 300; }\n  .add-users-container label {\n    font-size: 12px;\n    color: #5B6779; }\n  .add-users-container .users-to-add .users-body {\n    padding-top: 0; }\n    .add-users-container .users-to-add .users-body tbody:not(first-of-type) .list-user-email {\n      border-radius: 3px 0 0 3px; }\n    .add-users-container .users-to-add .users-body tbody:not(first-of-type) .icons {\n      border-radius: 0 3px 3px 0; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/app-users-editor/app-users-editor.component.scss
// module id = ../../../../../src/app/shared/components/app-users-editor/app-users-editor.component.scss
// module chunks = 12